import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'checkList';

const checkListService = {
  getCheckListTemplates: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/templates`,
      data,
    });
  },

  createCheckListTemplate: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateCheckListTemplate: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteCheckListTemplate: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  createCheckList: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkList`,
      data,
    });
  },

  updateCheckList: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/checkList/${encodeURIComponent(id)}`,
      data,
    });
  },

  updateStatus: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/check/${encodeURIComponent(id)}`,
      formData: true,
      data,
    });
  },

  deleteCheckList: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/check/checkList/${encodeURIComponent(id)}`,
      data,
    });
  },

  getAllTemplate: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/checkListTemplates`,
    });
  },
};

export default checkListService;
